import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

/**
 * Функция удаления конфигурации
 * @param config_id
 * @param cabinet_id
 */
export const useConfiguratorDelete = (config_id: number, cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: () =>
      http.del(`/cabinets/${cabinet_id}/admin/configurator`, {
        id: config_id,
      }),
  })

  const remove = async () => {
    try {
      await mutation.mutateAsync()

      addSuccess(trs('itf.config_removed'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}

/**
 * Функция перемещения конфигураций
 * @param cabinet_id
 */
export const useConfiguratorMove = (cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: { target_id: number; main_id: number }) =>
      http.put(`/cabinets/${cabinet_id}/admin/configurator/move`, data),
  })

  const move = async (data: { target_id: number; main_id: number }) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.config_moved'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    move,
  }
}

/**
 * Функция обновления/сохранения конфигураций
 * @param cabinet_id
 */
export const useConfiguratorSave = (cabinet_id: number) => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.id) {
        return http.put(`/cabinets/${cabinet_id}/admin/configurator`, data)
      } else {
        return http.post(`/cabinets/${cabinet_id}/admin/configurator`, data)
      }
    },
  })

  const save = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.config_save'))

      await queryClient.invalidateQueries({
        queryKey: ['load_cabinet_admin_configurator', cabinet_id],
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    save,
  }
}
